import React from 'react';

export const PrefixAsteriskWrapper = ({ children }) => <div className='prefix-asterisk'>{children}</div>;
